import { urls } from '../config/urls';
import { instance } from '../config/axios';

const { server } = urls;

let vehicleAbortController: AbortController;
export { vehicleAbortController };

export default {

  abortFetch () {
  },

  getVehicleById (id: number) {
    vehicleAbortController = new AbortController();
    return instance.get(`${server.vehicle}/${id}`, {
      signal: vehicleAbortController.signal
    });
  },
};
